import StringUtils from "@/utils/StringUtils";
import RcDomainMap from "../../../../common/RcDomainMap.js";
import CheckListItemOptionMap from "../option/CheckListItemOptionMap.js";
import ChecklistItemResult from "./ChecklistItemResult.js";
import InspectionUtils from "../../../inspection/InspectionUtils.js";

export default class ChecklistItemResultMap extends RcDomainMap {

  static MODEL_NAME = "CheckListItemResultMap";

  constructor(domain, data) {
    super(domain, data, ChecklistItemResultMap.MODEL_NAME);
  }

  find() {
    var keys = this.keys();
    var found = new ChecklistItemResultMap(this.domain, {});
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getChecklistItemResult(key);
      if (item.isNew()) {
        found.add(item);
      } else {
        var data = this.domain.checklists().items().results().findById(key);
        item = new ChecklistItemResult(this.domain, data);
        found.add(item);
      }
    }

    return found;
  }

  populate() {
    var found = this.find();
    this.addAll(found);
    var list = this.list();
    for (var i = 0; i < list.length; i++) {
      var item = list[i];
      item.populate();
    }
    return this
  }

  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getChecklistItemResult(key);
      values.push(item);
    }
    return values;
  }

  sorted() {
    var list = this.list();
    return list.sort(InspectionUtils.SortByCreatedDate);
  }

  findForItem(item) {
    var found = new ChecklistItemResultMap(this.domain, {});
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var itemResult = this.getChecklistItemResult(key);
      if (itemResult.item().idEquals(item)) {
        found.add(itemResult);
      }
    }

    return found;
  }

  // The answers to a Rollup's nested questions given in the same pass as `rowResult`
  // (the row's answer), in the Rollup's question order. A nested answer is an ordinary
  // answer whose question is one of the Rollup's nested questions, with the row's
  // resultType. `rollup` is the Rollup item - live, or from the frozen copy.
  findRollupAnswers(rollup, rowResult) {
    var found = [];
    if (!rollup.isRollup() || !rowResult.hasResultType()) {
      return found;
    }
    var nested = rollup.rollupItemList();
    var list = this.list();
    nested.forEach(question => {
      list.forEach(answer => {
        if (answer.item().idEquals(question)
            && StringUtils.eic(answer.resultType(), rowResult.resultType())) {
          found.push(answer);
        }
      });
    });
    return found;
  }

  repairedItemOptions() {
    let map = new CheckListItemOptionMap(this.domain, {});
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var itemResult = this.getChecklistItemResult(key);
      let repairedOptions = itemResult.repairedItemOptions();
      if (repairedOptions.size() != 0) {
        map.addAll(repairedOptions);
      }
    }
    return map;
  }

  initial() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var result = this.getChecklistItemResult(key);
      if (result.isInitial()) {
        return result
      }
    }
    return new ChecklistItemResult(this.domain)
  }

  enroute() {
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var result = this.getChecklistItemResult(key);
      if (result.isEnroute()) {
        return result
      }
    }
    return new ChecklistItemResult(this.domain)
  }

  first() {
    var all = this.list();
    if (all.length > 0) {
      return all[0];
    }
    return new ChecklistItemResult(this.domain);
  }

  getChecklistItemResult(key) {
    var value = super.get(key);
    return new ChecklistItemResult(this.domain, value);
  }

  mostSevereUnfixedDefectType() {
    var keys = this.keys();
    let defectType = "";
    let tempType = "";
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var itemResult = this.getChecklistItemResult(key);
      let resultType = itemResult.resultType();
      if (StringUtils.eic(tempType, "major")) {
        tempType = resultType;
      }
      if (tempType.length == 0 && StringUtils.eic(tempType, "minor")) {
        tempType = resultType;
      }
      if (tempType.length == 0) {
        tempType = resultType;
      }
    }

    defectType = tempType;
    return defectType;
  }

  copy() {
    var data = this._copy();
    return new ChecklistItemResultMap(this.domain, data);
  }

  addChecklistItemResult(itemResult) {
    super.add(itemResult);
    return this;
  }

  load() {
    let map = new ChecklistItemResultMap(this.domain);
    let keys = this.keys();
    for (let key in keys) {
      let result = this.getChecklistItemResult(keys[key]);
      result.load();
      map.add(result);
    }
    this.addAll(map);
  }
}